const beaconWidgetIds = {
    GENERAL: 'c0823c38-a478-44d0-9340-3619f7c98089',
    THEME: '38e34c9e-18f8-49d5-9bfd-55f892818099',
    APP: '0da41254-491b-47d6-b9d8-ec497dec5c6d'
}

export default beaconWidgetIds;
